import axiosInstance from "../axiosInstance";

export const updateUserName = async (data) => {
  try {
    const response = await axiosInstance.post("/update_username", data);
    return response.data;
  } catch (error) {
    console.error("Error sending username ", error);
    throw error;
  }
};

export const getUserData = async () => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;

    const response = await axiosInstance.get("/get_user_data", {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error get order data", error);
    throw error;
  }
};

export const reorder = async (id) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;

    const response = await axiosInstance.post(
      "/reorder",
      { orderId: id },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting order data", error);
    throw error;
  }
};
